<template>
    <button @click="downloadFile" class="publicDownloadBtn">{{text}}</button>
</template>

<script>
    import {downloadJobFile} from "../../../api/translator";


    export default {
        name: "download",
        props:{
            text:{
                type:String, required:true
            },
            downloadId:{
                required: true
            },
            downloadType:{
                type: String, required: true
            },
            downloadFileType:{
                type: String
            },
        },
        methods:{
            downloadFile(){
                downloadJobFile(this.downloadId, this.downloadType, this.downloadFileType)
                .then(data=>{
                    console.log(data)
                })
                .catch(response=>{
                    var reader = new FileReader();
                    reader.readAsText(response.data, 'utf-8');
                    var self = this;
                    reader.onload = function () {
                        try {
                            // 得到将bolob转换后的json数据, 如果不是json数据 好像会报错，所以在地下捕获错误就是正常的文件流了
                            var resData = JSON.parse(reader.result);
                            if(resData.code != 0){
                                self.$message.error("文件下载失败！")
                            }
                        } catch (e) {
                            const blob = new Blob([response.data]);
                            const fileName = decodeURI(response.headers.filename);
                            if ('download' in document.createElement('a')) { // 非IE下载
                                const elink = document.createElement('a');
                                elink.download = fileName;
                                elink.style.display = 'none';
                                elink.href = URL.createObjectURL(blob);
                                document.body.appendChild(elink);
                                elink.click();
                                window.URL.revokeObjectURL(elink.href);// 释放URL 对象
                                document.body.removeChild(elink)
                            } else { // IE10+下载
                                navigator.msSaveBlob(blob, fileName)
                            }
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.publicDownloadBtn{
     color: #0455A7;
    font-size: 14px;
}
</style>